
    import { mapGetters } from 'vuex';
    import JobPay from '@/utils/JobPay.class';

    export default {
        name: 'HistogramChart',

        data() {
            return {};
        },

        computed: {
            ...mapGetters('job', {
                $_isChartTypeRange: 'isChartTypeRange',
                $_chartData: 'chartData',
                $_isChartTypeHistogram: 'isChartTypeHistogram',
                $_isPayTypeHourly: 'isPayTypeHourly',
                $_payType: 'payType',
                $_pay: 'pay',
                $_marketPay: 'marketPay',
            }),

            jobRangeBarStyle() {
                let payMin = this.$_pay.payMin;
                let payMax = this.$_pay.payMax;

                if (this.$_payType === 'per_day') {
                    payMin = payMin * 253;
                    payMax = payMax * 253;
                }

                if (this.$_payType === 'per_month') {
                    payMin = payMin * 12;
                    payMax = payMax * 12;
                }

                payMin = Math.min(this.$_marketPay.payMin, payMin);
                payMax = Math.max(this.$_marketPay.payMax, payMax);

                const jobRangeGap = Math.min(this.$_pay.payMax, 350000) - Math.min(this.$_pay.payMin, 345000);
                const marketRangeGap = payMax - payMin;
                // calc to compensate the 2x border of the bar
                const width = `${Math.min(Math.round((jobRangeGap * 100) / marketRangeGap), 100) + 2}%`;
                let left = Math.max(Math.round(((Math.min(this.$_pay.payMin, 345000) - payMin) * 100) / marketRangeGap), 0);

                if (!left) {
                    left = '-1';
                }
                left += '%';

                return {
                    width,
                    left,
                };
            },

            chartData() {
                const payMin = this.$_pay.payMin;
                const payMax = this.$_pay.payMax;

                return this.$_chartData.map((o) => {
                    let barClass = '';
                    let barHeight = '';
                    let barPayLabel = '';
                    if (this.$_isChartTypeHistogram) {
                        let chartPayMin = o.min_pay;
                        let chartPayMax = o.max_pay;

                        if (this.$_isPayTypeHourly) {
                            chartPayMin = Math.round(chartPayMin / 1976);
                            chartPayMax = Math.round(chartPayMax / 1976);
                        } else if (this.$_payType === 'per_day') {
                            chartPayMin = Math.round(chartPayMin / 253);
                            chartPayMax = Math.round(chartPayMax / 253);
                        } else if (this.$_payType === 'per_month') {
                            chartPayMin = Math.round(chartPayMin / 12);
                            chartPayMax = Math.round(chartPayMax / 12);
                        }

                        if (
                            ((payMin <= chartPayMax && payMax >= chartPayMin) && payMax >= chartPayMax) ||
                            (payMin >= chartPayMin && payMin <= chartPayMax) ||
                            (payMax <= chartPayMax && payMax >= chartPayMin)
                        ) {
                            barClass = 'is-secondary';
                        }
                        if ((this.predictedValue <= chartPayMax && this.predictedValue >= chartPayMin)) {
                            barClass = 'is-success';
                        }

                        barHeight = Math.round(o.bar_height * 100);

                        if (barHeight < 5) {
                            barHeight = 5;
                        }
                        const s = new JobPay(chartPayMin, chartPayMax, this.$_payType);
                        barPayLabel = s ? s.payMinMaxShortLabel : '';
                    }
                    return {
                        bar_height: barHeight,
                        bar_class: barClass,
                        barPayLabel,
                        job_count: o.job_count,
                        min_pay: o.min_pay,
                        max_pay: o.max_pay,
                    };
                });
            },
        },

        methods: {},
    };
